import React from 'react'
import { cn } from '../../lib/utils'
import { Box } from '../ui/foundation'

export interface PageContainerProps {
  children: React.ReactNode
  className?: string
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '7xl' | 'full'
  padding?: 'none' | 'sm' | 'md' | 'lg'
}

export const PageContainer: React.FC<PageContainerProps> = ({
  children,
  className,
  maxWidth = '7xl',
  padding = 'md',
}) => {
  const getMaxWidthClass = () => {
    switch (maxWidth) {
      case 'sm':
        return 'max-w-sm'
      case 'md':
        return 'max-w-md'
      case 'lg':
        return 'max-w-lg'
      case 'xl':
        return 'max-w-xl'
      case '2xl':
        return 'max-w-2xl'
      case '7xl':
        return 'max-w-7xl'
      case 'full':
        return 'max-w-full'
      default:
        return 'max-w-7xl'
    }
  }

  const getPaddingClass = () => {
    switch (padding) {
      case 'none':
        return ''
      case 'sm':
        return 'px-4 py-4'
      case 'md':
        return 'px-4 py-6 sm:px-6 lg:px-8'
      case 'lg':
        return 'px-6 py-8 sm:px-8 lg:px-12'
      default:
        return 'px-4 py-6 sm:px-6 lg:px-8'
    }
  }

  return (
    <Box
      as="div"
      className={cn(
        'mx-auto w-full',
        getMaxWidthClass(),
        getPaddingClass(),
        className
      )}
    >
      {children}
    </Box>
  )
}

export default PageContainer
